// GENERATED FILE - DO NOT MODIFY
export enum UnitSystem {
    Imperial = "imperial",
    Metric = "metric",
}

export let nameof = "UnitSystem";
